// src/components/FaunaRace/FaunaGameplayScreen.js
import React, { useEffect } from 'react';
import { faunaData } from '../../gameLogics/faunaRaceData';
import styles from './FaunaRace.module.css';
import { ACTIONS } from './FaunaRaceGame';
import FaunaVictoryModal from './FaunaVictoryModal';

// Komponen-komponen kecil (tidak berubah)
const FruitDisplay = ({ score, type }) => (
    <div className={styles.powerBar}>
        <div className={styles.fruitDisplay}>
            {Array.from({ length: 100 }).map((_, i) => (
                <div key={i} className={`${styles.fruitCell} ${i < score ? `${styles.filled} ${styles[type]}` : ''}`} />
            ))}
        </div>
    </div>
);

const FeedbackPopup = ({ isCorrect }) => (
    <div className={styles.feedbackPopup} style={{ color: isCorrect ? '#4caf50' : '#f44336' }}>
        {isCorrect ? '✅ BENAR!' : '❌ SALAH!'}
    </div>
);

// Fungsi helper untuk fullscreen (bisa dipindah ke file utilitas jika diinginkan)
const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch(err => alert("Mode layar penuh tidak didukung."));
    } else {
        document.exitFullscreen();
    }
};

function FaunaGameplayScreen({ state, dispatch }) {
    const { mode, questions, questionIndex, greenScore, redScore, feedback, winner } = state;
    const currentQuestion = questions[questionIndex];

    useEffect(() => {
        if (feedback) {
            const timer = setTimeout(() => {
                if (!winner) {
                    dispatch({ type: ACTIONS.NEXT_QUESTION });
                }
            }, 1200);
            return () => clearTimeout(timer);
        }
    }, [feedback, dispatch, winner]);

    if (!currentQuestion) {
        return <div className={styles.container}>Memuat Soal...</div>;
    }

    const options = faunaData[mode].options;

    return (
        <div className={styles.container}>
            {winner && <FaunaVictoryModal winner={winner} dispatch={dispatch} />}

            <div className={styles.gameScreen}>
                {/* --- BAGIAN HEADER --- */}
                <header className={styles.gameHeader}>
                    <div className={styles.questionBox}>
                        <div className={styles.animalImage}>{currentQuestion.emoji}</div>
                        <div className={styles.animalName}>{currentQuestion.name}</div>
                        <div className={styles.questionText}>
                            Soal {questionIndex + 1}: Klasifikasikan hewan ini!
                        </div>
                    </div>
                    <div className={styles.navigationButtons}>
                        <button 
                            className={`${styles.woodButton} ${styles.navButton}`} 
                            onClick={() => dispatch({ type: ACTIONS.GO_TO_SCREEN, payload: { screen: 'difficulty' } })}
                        >
                            KEMBALI
                        </button>
                        <button 
                            className={`${styles.woodButton} ${styles.navButton}`}
                            onClick={toggleFullscreen}
                        >
                            LAYAR PENUH
                        </button>
                    </div>
                </header>

                {/* --- BAGIAN ARENA PERMAINAN --- */}
                <main className={styles.gameArena}>
                    {/* Panel Tim Hijau (Kiri) */}
                    <div className={`${styles.teamPanel} ${styles.green}`}>
                        <div className={styles.teamHeader}>TIM KELAPA</div>
                        <div className={styles.answerButtons}>
                            {options.map((option, index) => (
                                <button 
                                    key={`green-${option}`} 
                                    className={`${styles.woodButton} ${styles.answerBtn}`} 
                                    onClick={() => dispatch({ type: ACTIONS.SUBMIT_ANSWER, payload: { team: 'green', answer: option } })} 
                                    disabled={!!feedback}
                                >
                                    {index + 1}: {option}
                                </button>
                            ))}
                        </div>
                        {feedback && feedback.team === 'green' && <FeedbackPopup isCorrect={feedback.isCorrect} />}
                    </div>

                    {/* Panel Skor (Tengah) */}
                    <div className={styles.centerDisplay}>
                        <div className={styles.powerBarContainer}>
                            <FruitDisplay score={redScore} type="mangga" />
                            <div className={styles.powerLabel}>🥭 {redScore} Buah</div>
                        </div>
                        <div className={styles.powerBarContainer}>
                            <FruitDisplay score={greenScore} type="kelapa" />
                            <div className={styles.powerLabel}>🥥 {greenScore} Buah</div>
                        </div>
                    </div>

                    {/* Panel Tim Merah (Kanan) */}
                    <div className={`${styles.teamPanel} ${styles.red}`}>
                        <div className={styles.teamHeader}>TIM MANGGA</div>
                        <div className={styles.answerButtons}>
                            {options.map((option, index) => (
                                <button 
                                    key={`red-${option}`} 
                                    className={`${styles.woodButton} ${styles.answerBtn}`} 
                                    onClick={() => dispatch({ type: ACTIONS.SUBMIT_ANSWER, payload: { team: 'red', answer: option } })} 
                                    disabled={!!feedback}
                                >
                                    {index + 1}: {option}
                                </button>
                            ))}
                        </div>
                        {feedback && feedback.team === 'red' && <FeedbackPopup isCorrect={feedback.isCorrect} />}
                    </div>
                </main>
            </div>
        </div>
    );
}

export default FaunaGameplayScreen;